<template>
	<div class="ai-page" id="ai-page">
		<!-- <div class="ai-box">
			<div class="ai-logo">
				<div class="logo">
					<img src="../assets/images/touxiang.png" width="60" height="60" />
				</div>
				<div class="name">石柱房产</div>
			</div>
			<div class="ai-cate">
				<div class="item" :class="{active:active==0}" @click="selectCate(0)">
					发布租房
				</div>
				<div class="item" :class="{active:active==1}" @click="selectCate(1)">
					发布二手房
				</div>
				<div class="item" :class="{active:active==2}" @click="selectCate(2)">
					发布商铺
				</div>
				<div class="item" :class="{active:active==3}" @click="selectCate(3)">
					收费说明
				</div>
			</div>
			<div class="question">
				<div class="item">桥头镇乡村振兴示范项目有哪些？
					<van-icon name="arrow" size="12" color="#1e3b63"></van-icon>
				</div>
				<div class="item">桥头镇乡村振兴示范项目有哪些？
					<van-icon name="arrow" size="12" color="#1e3b63"></van-icon>
				</div>
				<div class="item">
					桥头镇乡村振兴示范项目有哪些？
					<van-icon name="arrow" size="12" color="#1e3b63"></van-icon>
				</div>
			</div>
		</div> -->
		<div class="ai-chat-title">
			您好，请问有什么可以帮助您?
		</div>
		<div class="hot-area">
			<div class="hot-area-item">热门小区</div>
			<div class="hot-area-item" @click="()=>{ask='财信城';sendFetch()}">财信城</div>
			<div class="hot-area-item" @click="()=>{ask='好望山';sendFetch()}">好望山</div>
			<div class="hot-area-item" @click="()=>{ask='隆鑫花漾城';sendFetch()}">隆鑫花漾城</div>
		</div>
		<div class="tag-box">
			<div class="tag-box-top">
				<div class="tag-item " :class="{active:active==0}" @click="()=>{active=0}">
					租房
				</div>
				<div class="tag-item" :class="{active:active==1}" @click="()=>{active=1}">
					二手房
				</div>
				<div class="tag-item" :class="{active:active==2}" @click="()=>{active=2}">
					商铺
				</div>
			</div>
			<div class="tag-box-list" v-if="active==0">
				<router-link class="tag-box-list-item" v-for="(item,index) in zufangs" :key="index" v-if="index<5"
					:to="'/zufang/view/'+item.id">
					<div class="num"><span>{{index+1}}</span></div>
					<div class="title">
						{{item.title}}
					</div>
				</router-link>
			</div>
			<div class="tag-box-list" v-if="active==1">
				<router-link class="tag-box-list-item" v-for="(item,index) in ershoufangs" :key="index" v-if="index<5"
					:to="'/ershoufang/view/'+item.id">
					<div class="num"><span>{{index+1}}</span></div>
					<div class="title">
						{{item.title}}
					</div>
				</router-link>
			</div>
			<div class="tag-box-list" v-if="active==2">
				<router-link class="tag-box-list-item" v-for="(item,index) in shops" :key="index" v-if="index<5"
					:to="'/shop/view/'+item.id">
					<div class="num"><span>{{index+1}}</span></div>
					<div class="title">
						{{item.title}}
					</div>
				</router-link>
			</div>
		</div>

		<div class="quik-menu">
			<router-link class="quik-menu-item" to="/diy/1">
				<img src="../assets/images/hot.png" class="icon" />
				石柱好房
			</router-link>
			<router-link class="quik-menu-item" to="/pagesShop/post/index">
				<img src="../assets/images/fabu.png" class="icon" />
				发布信息
			</router-link>
			<router-link class="quik-menu-item" to="/user">
				<img src="../assets/images/ruzhu.png" class="icon" />
				个人中心
			</router-link>
		</div>
		<div class="scroll-view-box">
			<div class="scroll-view-list">
				<div class="scroll-view" v-for="(item, index) in message" :key="index">
					<div class="scroll-view-top " :class="{ left: item.role == 'robot' }">
						<div v-if="item.role == 'user'" style="margin-right: 10px;">
							{{nickname?nickname:'游客'}}
						</div>
						<div class="avatar-box">
							<img src="../assets/images/touxiang.png" class="avatar" v-if="item.role == 'robot'" />
							<span v-if="item.role == 'user'">
								<img :src="avatar" class="avatar" v-if="avatar" />
								<img src="../assets/images/touxiang.png" class="avatar" v-else />
							</span>

						</div>
						<div v-if="item.role == 'robot'" style="margin-right: 10px;">
							<div style="margin-left: 10px;">
								石柱房产助手
							</div>
						</div>
					</div>
					<div class="scroll-view-content" :class="{ left: item.role == 'robot' }">
						<div class="parse">
							<div v-html="renderedMarkdown(item.content)" class="div-content"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ai-chat-box ">
		 
			<div class="ai-chat" :class="{active:isRecording}">
				<van-field style="width: 300px;" v-model="ask" :border="false" label="" placeholder="请输入你想问的"
					@keyup.enter="sendFetch" />
				<div class="ai-chat-btn active" @click="sendFetch" v-if="ask">
					<img src="../assets/images/send.png" class="img" />
				</div>
				<div class="ai-chat-btn ai-chat-close" v-if="isThink" @click="closed">
					<img src="../assets/images/stop.png" class="img" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var root = process.env.VUE_APP_API_URL;
	import Footbar from "./commpents/footbar";


	import {
		Tabbar,
		TabbarItem,
		Grid,
		GridItem,
		Image,
		Tag,
		Row,
		Col,
		Button,
		NoticeBar,
		Tab,
		Tabs,
		Swipe,
		SwipeItem,
		Icon,
		PullRefresh,
		Loading,
		Field
	} from "vant";

	export default {
		components: {
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Image.name]: Image,
			[Tag.name]: Tag,
			[Row.name]: Row,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Col.name]: Col,
			[Icon.name]: Icon,
			[Button.name]: Button,
			[NoticeBar.name]: NoticeBar,
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[PullRefresh.name]: PullRefresh,
			[Loading.name]: Loading,
			[Field.name]: Field,
			Footbar,
		},

		data() {
			return {
				getInitUrl: root + "user/index",
				getZufangUrl: root + "default/zufang",
				getErshoufangUrl: root + "default/ershoufang",
				getShopUrl: root + "default/shop",
				getLoupanUrl: root + "default/loupan",
				getJishouUrl: root + "default/jishou",
				getHaofangUrl: root + "default/haofang",
				nickname: '',
				avatar: '',
				controller: null,
				active: 0,
				isRecording: false,
				isThink: false,
				ask: '',
				currentChat: '',
				message: [],
				zufangs: [],
				ershoufangs: [],
				shops: []
			};
		},
		computed: {
			views: function() {
				if (this.clicks > 10000) {
					return (this.clicks / 10000).toFixed(1);
				} else {
					return this.clicks;
				}
			},
		},
		mounted() {
			// 监听内容变化（MutationObserver）
			// const observer = new MutationObserver(this.scrollToBottom);
			// observer.observe(document.body, {
			// 	childList: true,
			// 	subtree: true
			// });

			this.getZufang()
			this.getErshoufang()
			this.getShop()
			this.getUser()
		},

		methods: {
			getUser() {
				var self = this;
				$.ajax({
					url: self.getInitUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						if (reponseData.data.islogin == 1) {
							self.nickname = reponseData.data.nickname;
							self.avatar = reponseData.data.avatar;
						}

					},
					error: function() {
						self.$toast("system error");
					}
				});
			},
			sendFetch() {
				if (this.ask == '') {
					return
				}
				this.$set(this.message, this.message.length, {
					role: 'user',
					content: this.ask
				})

				let ask = this.ask
				this.fetchData(ask)
				this.ask = ''
			},
			async fetchData(ask) {

				try {
					let length = this.message.length
					this.isThink = true
					this.currentChat = ''
					this.message[length] = {
						role: 'robot',
						content: '正在思考中...'
					}
					setTimeout(()=>{
						this.scrollToBottom()
					},50)
					
					let message = [{
						"role": "user",
						"content": [{
							"type": 'text',
							"text": ask
						}]
					}]

					let response = null
					this.controller = new AbortController();
					const signal = this.controller.signal;
					const body = {
						"appId": '67f4d28870c85bc9ca17a550',
						"chatId": '',
						"messages": message,
						"stream": true,
						"detail": false
					}
					const options = {
						method: 'POST',
						headers: {
							'Authorization': 'Bearer fastgpt-j15iSqGvSuL9r1XOtS6mmP8tvI39kFEn4lE50bMybZeoiumKJW7ggSDZDdm9L',
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(body),
						signal,
					};
					response = await fetch('https://ai.45win.com/fastgpt/api/v1/chat/completions', options)

					if (!response.ok) {
						throw new Error('Network response was not ok');
					}

					const reader = response.body.getReader();
					const decoder = new TextDecoder();
					let buffer = '';
					let fullContent = '';

					while (true) {
						const {
							done,
							value
						} = await reader.read();
						if (done) break;

						buffer += decoder.decode(value);
						const chunks = buffer.split('data: ');

						chunks.slice(1).forEach(chunk => {
							try {
								if (chunk.trim() === '[DONE]') {
									this.isThink = false
									this.isBack = false
									this.scrollToBottom()
									return
								}
								const json = JSON.parse(chunk);
								const content = json.choices[0].delta.content || '';
								if (content) {
									this.currentChat += content;
									this.$set(this.message, length, {
										role: 'robot',
										content: this.currentChat
									})
									this.scrollToBottom()
								}
								console.log('当前片段:', content); // 实时输出
							} catch (e) {
								console.error('解析失败:', e);
							}
						});
						buffer = chunks.pop(); // 保留未完成部分
					}
				} catch (error) {
					console.log(error)
					this.isThink = false
					this.isBack = false

				}
			},
			Share() {
				var title = "石柱房产网-买房.卖房.租房-找石柱生活网帮忙！";
				var description =
					"提供石柱县新楼盘、二手房、租房、商铺；房屋买卖，找石柱生活网房小二帮忙！";
				var avatar = "http://fc.45win.com/house/web/images/logo.png";
				var url = window.location.href;
				this.setShare(title, description, url, avatar);
			},
			selectCate(active) {
				this.active = active
			},
			scrollToBottom() {
				window.scrollTo(0, document.body.scrollHeight);
			},
			closed() {
				this.controller.abort()
				this.isThink = false
			},
			renderedMarkdown(markdownContent) {
				return marked.parse(markdownContent);
			},
			getZufang() {
				var self = this;
				$.ajax({
					url: self.getZufangUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.zufangs = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getErshoufang() {
				var self = this;
				$.ajax({
					url: self.getErshoufangUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.ershoufangs = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
			getShop() {
				var self = this;
				$.ajax({
					url: self.getShopUrl,
					timeout: 120000,
					dataType: "json",
					type: "get",
					data: {
						type: self.type
					},
					headers: self.getRequestHeader(),
					success: function(reponseData, status) {
						self.shops = reponseData.data
					},
					error: function() {
						self.$toast("system error");
					},
				});
			},
		},
	};
</script>

<style scoped>
	.ai-page {
		background-image: url('https://house.45win.com/app-house/attachment/upload/2025/04/6800b913f10e0.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		min-height: 100vh;
		width: 100%;
		display: flex;
		flex-direction: column;
		overflow-y: auto;
	}

	.ai-cate {
		width: 315px;
		display: flex;
		justify-content: space-between;
		margin: 20px 0 25px 0;
	}

	.ai-cate .item.active {
		background-color: rgb(55, 114, 227);
		color: #fff;
	}


	.ai-cate .item {
		border-radius: 20px;
		box-shadow: 0 0 10px rgba(55, 114, 227, 0.5);
		color: #1e3b63;
		padding: 8px 10px;
		font-size: 12px;
	}

	.ai-box {
		padding: 15px;
		background-color: rgba(255, 255, 255, 0.5);
		border-radius: 15px;
		border: rgba(255, 255, 255, 0.4) 2px solid;
		margin: 80px 15px 15px 15px;
		color: #333;
		position: relative;
		width: 345px;
		box-sizing: border-box;
	}

	.ai-box .question .item {
		display: flex;
		justify-content: space-between;
		overflow: hidden;
		align-items: center;
		font-size: 14px;
		line-height: 1.5;
		border-radius: 22px;
		padding: 11px 15px;
		margin-bottom: 15px;
		color: #1e3b63;
		background-color: #fff;
	}

	.ai-logo {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		margin-top: -60px;
	}

	.ai-logo .logo {
		background-color: #fff;
		border-radius: 50%;
		padding: 10px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 10px;
	}

	.ai-logo .name {
		font-size: 18px;
		font-weight: 700;
		color: #1e3b63;
		line-height: 1.5;
		margin-bottom: 6px;
	}

	.quik-menu {
		display: flex;
		padding: 15px;
		gap: 10px;
	}

	.quik-menu .quik-menu-item {
		background-color: rgba(255, 255, 255, 0.6);
		border-radius: 8px;
		width: 70px;
		height: 70px;
		font-size: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		color: #1e3b63;
	}

	.quik-menu .quik-menu-item .icon {
		width: 24px;
		height: 24px;
		margin-bottom: 5px;
	}
	.hot-area{
		display: flex;
		padding:0 15px;
		 margin-bottom: 15px;
	}
	.hot-area .hot-area-item{
		background-color: rgba(255, 255, 255, 0.6);
		border-radius: 4px;
		color: #1e3b63;
		font-size: 14px;
		padding: 4px 8px;
		margin-right:10px;
	}
	.ai-chat-title {
		padding: 8px 13px;
		background-color: rgba(255, 255, 255, 0.5);
		border-radius: 8px;
		border: rgba(255, 255, 255, 0.4) 2px solid;
		margin: 40px 15px 15px 15px;
		color: #333;
		position: relative;
		font-size: 14px;
		font-weight: 700;
		color: #1e3b63;
		line-height: 1.5;
	}

	.tag-box {
		background-color: rgb(225, 227, 252);
		border-radius: 8px;
		margin: 0 15px;
	}

	.tag-box .tag-box-top {
		display: flex;
		align-items: center;
		padding: 10px 10px 0 10px;
	}

	.tag-box .tag-box-top .tag-item {
		height: 36px;
		color: #1e3b63;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
		border-radius: 8px 8px 0 0;
		padding: 0 10px;
		font-size: 14px;
		width: 60px;
	}

	.tag-box .tag-box-top .tag-item.active {
		background-color: rgb(241, 244, 253);
	}

	.tag-box .tag-box-list {
		background-color: rgba(255, 255, 255, 0.5);
		border-radius: 8px;
		padding: 10px;
		line-height: 2;
	}

	.tag-box .tag-box-list .tag-box-list-item {
		display: flex;
		align-items: center;
	}

	.tag-box .tag-box-list .tag-box-list-item .title {
		color: #1e3b63;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		flex: 1;
		font-size: 14px;
	}

	.tag-box .tag-box-list .tag-box-list-item .num {
		background-color: #5787df;
		border-radius: 4px;
		color: #fff;
		font-size: 11px;
		margin-right: 4px;
		width: 16px;
		height: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tag-box .tag-box-list .tag-box-list-item:nth-child(1) .num {
		background-color: #ff0000;
	}

	.tag-box .tag-box-list .tag-box-list-item:nth-child(2) .num {
		background-color: #f5a600;
	}

	.tag-box .tag-box-list .tag-box-list-item:nth-child(3) .num {
		background-color: #00c3b6;
	}

	.ai-chat-box {
		position: fixed;
		bottom: 20px;
		z-index: 10;
		width: 100%;
	}

	.ai-chat-box .ai-chat {
		background-color: #fff;
		border-top: #f5f5f5 1px solid;
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 50px;
		flex-wrap: wrap;
		border-radius: 10px 10px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
		box-sizing: border-box;
		margin: 0 15px;
		padding-right: 15px;
		overflow: hidden;
	}

	.ai-chat-box .ai-chat .img {
		width: 18px;
		height: 18px;
	}

	.ai-chat .ai-chat-btn {
		display: flex;
		-webkit-box-align: center;
		align-items: center;
		-webkit-box-pack: center;
		justify-content: center;
		flex-shrink: 0;
		height: 24px;
		width: 24px;
		border-radius: 50%;
		background: #333;
		cursor: not-allowed;
		line-height: 1;

	}

	.ai-chat .ai-chat-btn.ai-chat-close {
		animation: pulse 0.8s infinite;
	}

	.ai-chat .ai-chat-btn.active {
		background-color: #007aff;
	}

	@keyframes pulse {
		0% {
			transform: scale(0.9);
		}

		50% {
			transform: scale(1.2);
		}

		100% {
			transform: scale(0.9);
		}
	}

	.scroll-view-box {
		padding-bottom: 100px;
	}

	.scroll-view-box .scroll-view {
		margin: 15px;
	}

	.scroll-view-box .scroll-view .scroll-view-top {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		color: #1e3b63;
		font-size: 16px;

	}

	.scroll-view-box .scroll-view .scroll-view-top .tool {
		display: flex;
		align-items: center;
		margin-left: 10px;
		border: #e2e8f0 1px solid;
		border-radius: 6px;
	}

	.scroll-view-box .scroll-view .scroll-view-top .tool .item {
		border-right: #e2e8f0 1px solid;
		width: 28px;
		height: 28px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.scroll-view-box .scroll-view .scroll-view-top .tool .item .icon {
		width: 16px;
		height: 16px;
	}

	.scroll-view-box .scroll-view .scroll-view-top .tool .item:last-child {
		border-right: none;
	}

	.scroll-view-box .scroll-view .scroll-view-top.left {
		justify-content: flex-start;
	}

	.scroll-view-box .scroll-view .scroll-view-top .avatar-box {
		width: 36px;
		height: 36px;
		border-radius: 6px;
		border: 1px solid rgb(223, 226, 234);
		box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.scroll-view-box .scroll-view .scroll-view-top .avatar-box .avatar {
		width: 32px;
		height: 32px;
		border-radius: 6px;
	}

	.scroll-view-box .scroll-view .scroll-view-content {
		text-align: right;
		position: relative;
		z-index: 1;
	}

	.scroll-view-box .scroll-view .scroll-view-content .parse {
		padding: 5px 18px;
		background-color: #5787df;
		border-radius: 24px 5px 24px 24px;
		line-height: 1.8;
		margin-top: 10px;
		text-align: left;
		display: inline-block;
		width: max-content;
		max-width: 100%;
		font-size: 15px;
		color: #fff;
		box-sizing: border-box;
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
	}

	.scroll-view-box .scroll-view .scroll-view-content.left {
		text-align: left;

	}

	.scroll-view-box .scroll-view .left .parse {
		background-color: #ffffff;
		border-radius: 5px 24px 24px 24px;
		color: #1e3b63;
	}

	.scroll-view-box .scroll-view .first .parse::before {
		content: '';
		position: absolute;
		left: 6px;
		/* 向左偏移一个三角宽度 */
		top: 50%;
		transform: translateY(-35%);
		/* 垂直居中 */
		width: 0;
		height: 0;
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		border-right: 15px solid #fff;
		filter: drop-shadow(-5px 0 5px rgba(0, 0, 0, 0.1));
		/* 控制颜色和大小 */
		/* 控制三角形颜色和大小 */
	}

	.scroll-view-box .scroll-view .left .markdown {
		display: inline-block;
		content: "";
		width: 3px;
		height: 14px;
		transform: translate(4px, 2px) scaleY(1.3);
		background-color: #0055ff;
		animation: cursor-blink .6s infinite;
	}

	.div-content {
		word-break: break-all;
		text-align: justify;
		-moz-text-align-last: left;
		text-align-last: left;
		max-width: 100%;
		box-sizing: border-box;
		line-height: 1.6;
		font-size: 30rpx;
		overflow-y: auto;
	}

	.div-content /deep/ img {
		max-width: 100%;
	}

	.div-content /deep/ ul {
		display: block;
		list-style-type: disc;
		margin-block-start: 1em;
		margin-block-end: 1em;
		padding-inline-start: 40rpx;
		unicode-bidi: isolate;
		list-style: none;
	}

	.div-content /deep/ ol {
		display: block;
		list-style-type: disc;
		margin-block-start: 1em;
		margin-block-end: 1em;
		padding-inline-start: 40rpx;
		unicode-bidi: isolate;
		padding-left: 20px;
	}

	.div-content /deep/ ul li {
		display: list-item;
		text-align: -webkit-match-parent;
		unicode-bidi: isolate;
		margin: .5em 0;
	}

	.div-content /deep/ p,
	.div-content /deep/ h6,
	.div-content /deep/ h5,
	.div-content /deep/ h4,
	.div-content /deep/ h3,
	.div-content /deep/ h2,
	.div-content /deep/ h1,
	.div-content /deep/ hr {
		margin: .5em 0;
		padding: 0;
	}
</style>